import React from "react";
import SupportLayout from "./supportLayout";
import Faq from "common/pages/common/-pages/support/Faq";
import Seo from "components/Seo";

const MorningFaq = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="FAQ" />
            <SupportLayout>
                <Faq type="morning" />
            </SupportLayout>
        </React.Fragment>
    );
};

export default MorningFaq;
